import Vue from "vue";
import VueRouter from "vue-router";
import Buefy from "buefy";
import UnityMessageInit from "./util/unityMessages";
import { detectMobile } from "./util/detectMobile";

import App from "./App.vue";

import router from "./router";
import store from "./store";

import Plyrue from "plyrue";

store.dispatch("set_is_mobile", detectMobile());

Vue.use(Plyrue);
Vue.use(VueRouter);
Vue.use(Buefy);
Vue.config.productionTip = false;

//let's add a global event bus
const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");

window.getMessageFromUnity = UnityMessageInit(store);
